<template>
  <div class="header">
    <title>Taski</title>
    <!-- <nav class="navbar navbar-expand-lg navbar-light">
      <div class="d-flex flex-grow-1">
        <a class="navbar-brand" href="#">
          <img src="../assets/logo.png" width="40" height="40" class="d-inline-block align-top" alt />
          Taski
        </a>
        <div class="w-100 text-right">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#myNavbar"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
      <div class="collapse navbar-collapse flex-grow-1 text-right" id="myNavbar">
        <ul class="navbar-nav nav ml-auto flex-nowrap">
          <li class="nav-item">
            <a href="#" class="nav-link m-2 menu-item nav-active">Features</a>
          </li>
          <li class="dropdown">
            <a class="dropdown-toggle" data-toggle="dropdown" href="#">
              Page 1
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
              <li>
                <a href="#">Page 1-1</a>
              </li>
              <li>
                <a href="#">Page 1-2</a>
              </li>
              <li>
                <a href="#">Page 1-3</a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link m-2 menu-item">How We Help</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link m-2 menu-item">About</a>
          </li>
        </ul>
      </div>
    </nav>-->
    <div>
      <b-navbar toggleable="lg" type="light" variant="faded" fixed>
        <a href="#/">
          <div href="#/" class="navbar-brand mb-0">
            <img
              src="../assets/logo.png"
              width="40"
              height="40"
              class="d-inline-block align-top"
              alt
            />
            Taski
          </div>
        </a>
        <!-- As a heading -->

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-navbar-nav right>
              <a
                href="https://www.producthunt.com/posts/taski?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-taski"
                target="_blank"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=203650&theme=light"
                  alt="Taski - Your journey to productivity with better decisions 🚀 | Product Hunt Embed"
                  style="width: 250px; height: 45px;"
                  width="250px"
                  height="54px"
                />
              </a>
              <b-nav-item href="#/" style="font-weight:bold;">Home</b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav right>
              <b-nav-item href="#/how-it-works" style="font-weight:bold;">How it Works</b-nav-item>
            </b-navbar-nav>
            <b-nav-item-dropdown text="Toolkit" style="font-weight:bold;" right>
              <b-dropdown-item href="/#/eisen" style="font-weight:bold;">Eisenhower Matrix</b-dropdown-item>
              <b-dropdown-item href="/#/swot" style="font-weight:bold;">
                S.W.O.T
                <span style="color: #00b400; font-weight:bold;">[Popular]</span>
              </b-dropdown-item>
              <b-dropdown-item href="/#/moscow" style="font-weight:bold;">MoSCoW</b-dropdown-item>
              <b-dropdown-item href="/#/ikigai" style="font-weight:bold;">
                Ikigai
                <span style="color: #00b400; font-weight:bold;">[Popular]</span>
              </b-dropdown-item>
              <b-dropdown-item href="/#/rice" style="font-weight:bold;">R.I.C.E</b-dropdown-item>
              <b-dropdown-item href="/#/smart" style="font-weight:bold;">S.M.A.R.T</b-dropdown-item>
              <b-dropdown-item href="/#/daci" style="font-weight:bold;">
                D.A.C.I
                <span style="color: #b40000; font-weight:bold;">[New]</span>
              </b-dropdown-item>
              <b-dropdown-item href="/#/kanban" style="font-weight:bold;">Kanban</b-dropdown-item>
              <b-dropdown-item href="/#/procon" style="font-weight:bold;">Pro & Cons</b-dropdown-item>
              <b-dropdown-item href="/#/product-vision" style="font-weight:bold;">Product Vision</b-dropdown-item>
              <b-dropdown-item href="/#/spade" style="font-weight:bold;">S.P.A.D.E</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-navbar-nav right>
              <b-nav-item href="mailto:hello@usetaski.com" style="font-weight:bold;">Feedback</b-nav-item>
            </b-navbar-nav>

            <!-- <b-nav-form class="features">
              <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
              <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
            </b-nav-form>-->
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.header {
  padding-top: 2rem;
}

@media only screen and (min-width: 1025px) {
  .header {
    padding-top: 1.5rem;
    padding-left: 6rem;
    padding-right: 6rem;
  }
}

.navbar-brand {
  font-size: 32px;
  color: #d00000;
  font-weight: bold;
}

.navbar-brand:hover {
  font-size: 32px;
  color: #d00000;
  font-weight: bold;
}

.navbar-brand img {
  size: 32px;
}

.nav-link {
  font-size: 1rem;
  color: brown;
}
</style>